import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import StaticBanner from '../../../components/elements/StaticBanner';
import BannerImg from '../../../../public/assets/images/BannersFiles/26.jpg';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../shared/Helper';

const Youhavesame = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();

  const { pathname } = useLocation();


  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);
  return (
    <>
      <StaticBanner BannerImg={BannerImg} en_US={'You have Same'} arabic={false} />
      <div className="py-5">
        <section
          className={`  sm:h-90 flex xl:flex-row flex-col  just  py-1    sm:px-20 ${isActive ? 'text-left' : 'text-right'}`}
        >
          <img src={`/assets/images/1234.png`} className="   md:max-w-screen-sm" alt="" />
          <div className="xl:px-10 flex flex-col justify-center items-center   lg:pb-0">
            <h4
              className={`text-customgreen flex sm:text-2xl items-center leading-10 text-justify pt-1 px-10 xl:px-0 `}
            >
              {isActive
                ? `تمنحك خدمة "ولك مثله" فرصة المساهمة في نشر مشاريع الجمعية عبر مواقع التواصل الاجتماعي، وجمع نقاط مقابل كل
            عملية تبرع تأتي عبر الرابط الذي تقوم بنشره. تابع تأثيرك عبر صفحتك الخاصة، وعند جمعك ما يكفي من نقاط، سيتم
            ادراجك في لائحة الشرف`
                : `The "And You have the Same" service gives you the opportunity to contribute to the promotion of the association's projects through social media and earn points for every donation made through the link you share. Track your impact via your personal page, and when you collect enough points, you will be included in the honor roll.`}
            </h4>
            <div className="flex flex-row flex-wrap justify-center pt-3">
              <Link to={'/donorLogin'} target="_blank">
                <button
                  type="submit"
                  className="text-white mx-1 lg:mt-3 bg-customgreen hover:bg-hovergreen  font-medium rounded-full text-sm px-3 py-2.5 text-center"
                >
                  {t('Service Procedure')}
                </button>
              </Link>
              <Link to={'/CategoryList'}>
                <button
                  type="submit"
                  className="text-white mx-1 lg:mt-3 bg-customgreen hover:bg-hovergreen  font-medium rounded-full text-sm px-3 py-2.5 text-center"
                >
                  {t('Category List')}
                </button>
              </Link>
              {/* <Link to={'/donorLogin'} target="_blank">
                <button
                  type="submit"
                  className="text-white mx-1 lg:mt-3 bg-customgreen hover:bg-hovergreen  font-medium rounded-full text-sm px-3 py-2.5 text-center"
                >
                  {t('Login')}
                </button>
              </Link> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Youhavesame;
